// English strings -- the source catalog every other locale is checked against
// (scripts/i18n-check.js). Bundled with the app; other languages are
// locales/<code>.json and load on demand. See i18n.js.
//
// Keys are "<area>.<name>". Placeholders are {name}. A value may instead be
// an object of plural forms: { "one": "{count} member", "other": "{count} members" }.
// Keys read through tHtml() may contain markup; everything else is plain text.
export default {
    "header.logoAlt": "Intrivity",
    "header.contact": "contact",
    "header.login": "login",
    "header.logout": "logout",
    "header.printPdf": "print-pdf",
    "header.return": "return",
    "language.label": "Language",
    "domain.message.name": "Message",
    "domain.relationship.name": "Relationship",
    "domain.time.name": "Time",
    "domain.space.name": "Space",
    "domain.message.label": "Message Domain",
    "domain.relationship.label": "Relationship Domain",
    "domain.time.label": "Time Domain",
    "domain.space.label": "Space Domain",
    "nav.moodleError": "Could not connect to Moodle: {message}",
    "nav.selected": "{label} selected",
    "nav.overview": "Understanding Your Results",
    "nav.profile": "My MRTS Overall Score",
    "nav.detailedResults": "My Detailed Results",
    "nav.account": "My Account",
    "nav.teamProfile": "Team Profile",
    "nav.trainerCertification": "Trainer Certification",
    "nav.training": "Intrivity Training",
    "nav.adminOperations": "Admin Operations",
    "nav.administration": "Administration",
    "nav.printableOpened": "Printable report opened",
    "nav.downloadReport": "Download Full Report",
    "nav.roleGuide": "Role Guide",
    "nav.accessibility": "Accessibility",
    "nav.privacy": "Data Privacy",
    "nav.menu": "Menu",
    "nav.mainLabel": "Main",
    "auth.emailInUse": "An account with that email already exists. Try logging in instead.",
    "auth.weakPassword": "Password should be at least 6 characters.",
    "auth.incorrectCredentials": "Incorrect email or password.",
    "auth.invalidEmail": "That doesn't look like a valid email address.",
    "auth.userNotFound": "No account found for that email.",
    "auth.cancelled": "Sign-in was cancelled.",
    "auth.methodDisabled": "This sign-in method isn't enabled yet.",
    "common.genericError": "Something went wrong. Please try again.",
    "common.loading": "Loading...",
    "app.masqueradeNotFound": "Masqueraded user not found!",
    "app.profileSaveError": "There was a problem saving your profile.",
    "app.paymentSuccess": "Payment was successful... this site will redirect back to your Intrivity results but you will need to log back into the site.",
    "app.paymentFailed": "Payment failed.",
    "app.paymentCancelled": "Payment was cancelled... this site will redirect you back to My Intrivity...",
    "app.processingResults": "Processing your results…",
    "app.surveySubmitted": "Your survey has been submitted.",
    "app.preparingResults": "Please wait while we prepare your results…",
    "app.skipToContent": "Skip to main content",
    "app.stopMasquerade": "Stop Masquerade",
    "app.domainLoaded": "{domain} domain information loaded.",
    "common.cancel": "Cancel",
    "login.missingFields": "Please enter your email and password.",
    "login.passwordMismatch": "Passwords do not match.",
    "login.forgotNeedsEmail": "Enter your email address above first, then click \"Forgot password?\".",
    "login.resetSent": "Password reset email sent to {email}.",
    "login.resetFailed": "Could not send password reset email.",
    "login.createAccount": "Create Account",
    "login.logIn": "Log In",
    "login.google": "Continue with Google",
    "login.microsoft": "Continue with Microsoft",
    "login.or": "or",
    "login.missingName": "Please enter your first and last name.",
    "login.email": "Email",
    "login.password": "Password",
    "login.confirmPassword": "Confirm Password",
    "login.forgotPassword": "Forgot password?",
    "login.haveAccount": "Already have an account? Log in",
    "login.needAccount": "Need an account? Sign up",
    "overview.title": "UNDERSTANDING YOUR RESULTS",
    "overview.intro1": "Your personalized \"MRTS Profile\" defines your Human Interaction Style. It is composed of four numerals and their corresponding shapes which represent your style for each respective domain.",
    "overview.intro2": "The assessment evaluates your inclinations and tendencies across each of the four domains of Message, Relationship, Time, and Space and results in a raw score for each domain. Your raw score is assigned an MRTS numeral and corresponding shape based on the key below. This translates into your personalized four-digit MRTS profile, which serves as a shorthand to help you remember your individual tendencies in communicating across the four domains.",
    "overview.rawScoreLine1": "RAW",
    "overview.rawScoreLine2": "SCORE",
    "overview.shape5": ", shown as a filled square",
    "overview.shape4": ", shown as a clipped-corner square",
    "overview.shape3": ", shown as a large triangle in a square",
    "overview.shape2": ", shown as a small triangle in a square",
    "overview.shape1": ", shown as an open square",
    "overview.examples": "Examples:",
    "overview.janeIntro": "This is Jane's personalized profile. Her MRTS is 3453. It indicates her:",
    "overview.janeMessage": "message style is neutral (3)",
    "overview.janeRelationship": "relationship style is more relational (4)",
    "overview.janeTime": "time style is very flexible (5)",
    "overview.janeSpace": "space style is neutral (3)",
    "overview.johnIntro": "This is John's personalized profile. His MRTS is 3132. It indicates his:",
    "overview.johnMessage": "message style is neutral (3)",
    "overview.johnRelationship": "relationship style is very transactional (1)",
    "overview.johnTime": "time style is neutral (3)",
    "overview.johnSpace": "space style is somewhat reserved (2)",
    "badge.profile": "MRTS PROFILE",
    "common.required": "This field is required.",
    "domain.message.summary": "The indirectness and implicitness of a message.",
    "domain.space.summary": "The communication cues in the physical, auditory, and vocal space.",
    "domain.relationship.summary": "The role of status and the nature of relationship in communication.",
    "domain.time.summary": "The communication cues in the way one moves through time.",
    "profile.yourScore": "Your score: {label}",
    "profile.domainImageAlt": "{domain} domain",
    "profile.heading": "My MRTS Profile",
    "profile.goToDetails": "GO TO DETAILS",
    "profile.backToSummary": "BACK TO SUMMARY",
    "profile.describeDomain": "{domain}: {score} of 5, {label}",
    "profile.describe": "Your MRTS profile. {domains}.",
    "profile.chartLabel": "MRTS profile chart: your score in each of the four domains, with the spread of your team.",
    "profile.legendCount": "Scaled count of users per domain score.",
    "profile.legendDot": "Black dot represents your domain score.",
    "a11y.show": "Show {label}",
    "a11y.hide": "Hide {label}",
    "a11y.shape1": "open square",
    "a11y.shape2": "small triangle in a square",
    "a11y.shape3": "large triangle in a square",
    "a11y.shape4": "clipped-corner square",
    "a11y.shape5": "filled square",
    "a11y.rawScore": ", raw score {raw} out of 5",
    "a11y.mrtsScore": "{domain}: MRTS {score}",
    "domain.atWork": "At work, you are",
    "domainDetails.heading": "{domain} domain details",
    "domainDetails.attitudes": "ATTITUDES",
    "domainDetails.activate": "ACTIVATE",
    "domainDetails.sampleItem": "SAMPLE ITEM: {sample}",
    "domainDetails.noData": "No data for user.",
    "domainDetails.behaviors": "BEHAVIORS",
    "domainDetails.showBehaviors": "SHOW BEHAVIORS",
    "domainDetails.hideBehaviors": "HIDE BEHAVIORS",
    "domainDetails.characteristic": "CHARACTERISTIC",
    "domainDetails.characteristics": "characteristics",
    "domainDetails.atAGlance": "RESULTS AT A GLANCE",
    "domainDetails.domainRawCaption": "Domain raw score",
    "domainDetails.domainColumn": "DOMAIN",
    "domainDetails.behaviorCaption": "Characteristic and behavior raw scores for the {domain} domain",
    "domainDetails.behaviorColumn": "Behavior",
    "domainDetails.attitudeCaption": "Attitude raw scores for the {domain} domain",
    "domainDetails.attitudeColumn": "Attitude",
    "domainDetails.recommendations": "PERSONALIZED RECOMMENDATIONS",
    "domainDetails.behaviorRecommendations": "BEHAVIOR RECOMMENDATIONS",
    "domainDetails.attitudeRecommendations": "ATTITUDE RECOMMENDATIONS",
    "domainDetails.strengths": "YOUR STRENGTHS AND CHALLENGES",
    "domainDetails.behaviorStrengths": "BEHAVIOR STRENGTHS AND CHALLENGES",
    "domainDetails.attitudeStrengths": "ATTITUDE STRENGTHS AND CHALLENGES",
    "likert.scaleLabelled": "Scale from \"{left}\" on the left to \"{right}\" on the right, 1 to 4.",
    "likert.scale": "Scale from 1 to 4, left to right.",
    "likert.yourScore": "Your score: {score} of 4.",
    "likert.teamAt": "{count} at {score}",
    "likert.teamMembers": "Team members: {list}.",
    "likert.you": "You",
    "teams.heading": "My Teams",
    "teams.myTeams": "MY TEAMS",
    "teams.profileFor": "MRTS profile for {first} {last}",
    "ai.scoreLine": "You: {you} · Team: {team}",
    "ai.teamLevel": "<strong>Team-Level Report</strong> for {title}",
    "ai.groupLevel": "<strong>Group-Level Report</strong> for {title}",
    "ai.strengths": "Strengths",
    "ai.opportunities": "Opportunities",
    "ai.teamDynamics": "Team Dynamics:",
    "ai.sources": "Sources:",
    "ai.disclaimer": "This report contains original analysis drafted with AI tools (Gemini) and may contain inaccuracies. Please exercise independent judgment and verify all data-driven claims before relying on them. If you notice any errors when comparing this to your full MRTS report, please let us know with as much detail as possible; your feedback will help us improve future reports.",
    "ai.generatedAt": "Generated {date}",
    "ai.checkingAvailability": "Checking availability…",
    "ai.noDueDate": "This report is not available: no due date has been set for this group/team.",
    "ai.availableAfter": "This report will be available after {date}.",
    "ai.notLoaded": "Report data not fully loaded yet. Please try again in a moment.",
    "ai.generateFailed": "Failed to generate summary. Please try again.",
    "ai.pdfFailed": "Failed to generate PDF: {message}",
    "ai.popupBlocked": "Could not open the print window. Please allow pop-ups for this site.",
    "ai.heading": "INTRIVITY AI Summary Report",
    "ai.headingFor": "INTRIVITY AI Summary Report for {name}",
    "ai.close": "Close AI summary report",
    "ai.generatingPdf": "Generating PDF…",
    "ai.downloadPdf": "Download PDF",
    "ai.print": "Print",
    "ai.generating": "Generating summary — this may take a moment…",
    "ai.generate": "Generate AI Summary",
    "banner.assessmentFor": "Assessment for {name}",
    "banner.welcomeBack": "Welcome Back, {name}!",
    "banner.welcome": "Welcome!  Please log in to My Intrivity!",
    "banner.goToProfile": "Go to my MRTS profile. Message {m}, Relationship {r}, Time {t}, Space {s}.",
    "banner.compareWith": "Compare with",
    "pdf.preparingPdf": "Preparing your PDF…",
    "pdf.preparingZip": "Preparing your ZIP…",
    "common.teamMember": "Team Member {number}",
    "common.notSignedIn": "Not signed in.",
    "common.endpointFailed": "{name} failed with status {status}.",
    "printable.heading": "Printable Intrivity report",
    "printable.headingFor": "Printable Intrivity report for {name}",
    "common.unknownError": "unknown error",
    "common.submit": "Submit",
    "common.lastName": "Last Name",
    "common.firstName": "First Name",
    "common.title": "Title",
    "account.confirmSurvey": "This link will take you to the survey.  Are you sure you want to proceed?",
    "account.codeClaimed": "This Intrivity code has already been claimed.",
    "account.groupNotFound": "Could not find group reference.",
    "account.codeNoGroup": "This code is not associated with a group.",
    "account.codeNoMatch": "There was no match for this Intrivity code.",
    "account.addedToGroup": "You have been added to the group.",
    "account.joinFailed": "We couldn't add you to the group. Please try again, or contact your program manager.",
    "account.paymentGatewayError": "Error with payment gateway.",
    "account.paymentStartFailed": "Failed to start payment: {message}",
    "account.heading": "My Intrivity",
    "account.editName": "edit name",
    "account.confirmBadgeDownload": "Download your MRTS badge?",
    "account.downloadBadge": "Download your MRTS badge",
    "account.assessmentReport": "Intrivity Assessment Report",
    "account.fee": "Fee: {amount}",
    "account.activateFree": "Click to Activate Account, No Fee",
    "account.submitPayment": "Submit Payment",
    "account.additionalCode": "If you have received an additional Intrivity code, please enter it below to join another group:",
    "account.codeLabel": "Intrivity Code",
    "account.surveyProcessing": "Your survey is being processed.",
    "account.takeAssessment": "Take the Intrivity Assessment",
    "account.noGroup": "Your account is not associated with a group.",
    "account.enterCode": "To take the Intrivity survey, please enter an Intrivity code:",
    "account.teamSize": "Team Size: {count}",
    "account.membersOf": "Members of {title}",
    "account.membersOfThisGroup": "Members of this group",
    "account.photo": "Photo",
    "account.goToTeam": "GO TO TEAM",
    "profileField.image": "image",
    "profileField.organization": "organization",
    "profileField.title": "title",
    "profileField.saveError": "There was a problem saving your profile data.",
    "profileField.save": "save",
    "profileField.cancel": "cancel",
    "profileField.cancelEditing": "editing {field}",
    "profileField.edit": "edit {field}",
    "privacy.title": "Data Privacy",
    "privacy.lede": "Taking an Intrivity assessment means telling us things about how you communicate. This page explains what we hold, who can see it, and which other companies are involved in providing the service.",
    "privacy.holdHeading": "What we hold about you",
    "privacy.holdAccount": "<strong>Your account</strong> — your email address, your name, and the profile photo from whichever provider you signed in with (Google or Microsoft). If you signed up with a password instead, we hold your email and name; the password itself is held by Google Firebase Authentication and is never visible to us.",
    "privacy.holdProfile": "<strong>Your profile</strong> — the organisation and job title you enter yourself. Both are optional and you can change them at any time on the My Intrivity page.",
    "privacy.holdAnswers": "<strong>Your assessment answers</strong> — the responses you give in the survey.",
    "privacy.holdResults": "<strong>Your results</strong> — the MRTS scores calculated from those answers, and the written report generated from them.",
    "privacy.holdMembership": "<strong>Your group membership</strong> — which organisation, group or team you were invited into, and by whom.",
    "privacy.noCards": "We do not hold your payment card details. Where a fee applies, the payment is handled entirely by Stripe and we receive only confirmation that it succeeded.",
    "privacy.whoHeading": "Who can see your results",
    "privacy.who1": "Your individual report is yours. Beyond you, it can be seen by people holding an administrative role in the group you belong to — a trainer, a program manager, a client manager, or an Intrivity administrator. These roles exist so that someone can run a programme, chase up unfinished assessments and interpret results with a team.",
    "privacy.who2": "Other participants in your group do not see your individual report. They see the team-level view, which combines everyone's scores. By default the individuals within that combined view are anonymised. A group's administrator can switch that anonymisation off, in which case names are shown alongside scores to others in the same group.",
    "privacy.thirdPartyHeading": "Other companies involved",
    "privacy.thirdPartyIntro": "Running the assessment involves a small number of other services. Each one receives only what it needs to do its part.",
    "privacy.tableCaption": "Third-party services and what reaches them",
    "privacy.colService": "Service",
    "privacy.colDoes": "What it does",
    "privacy.colReceives": "What it receives",
    "privacy.service.firebase.name": "Google Firebase",
    "privacy.service.firebase.does": "Sign-in, database, file storage and server code",
    "privacy.service.firebase.receives": "Everything listed above. This is where the service runs.",
    "privacy.service.surveymonkey.name": "SurveyMonkey",
    "privacy.service.surveymonkey.does": "Delivers the assessment questionnaire",
    "privacy.service.surveymonkey.receives": "Your email address and your answers",
    "privacy.service.stripe.name": "Stripe",
    "privacy.service.stripe.does": "Takes payment where a fee applies",
    "privacy.service.stripe.receives": "Your payment details, directly — they do not pass through us",
    "privacy.service.gemini.name": "Google Gemini",
    "privacy.service.gemini.does": "Writes the optional AI Summary Report",
    "privacy.service.gemini.receives": "Your name and your scores. See below.",
    "privacy.service.analytics.name": "Google Analytics",
    "privacy.service.analytics.does": "Counts visits so we know which pages are used",
    "privacy.service.analytics.receives": "Usage data, subject to your cookie choice",
    "privacy.service.cookiebot.name": "Cookiebot",
    "privacy.service.cookiebot.does": "Records your cookie preferences",
    "privacy.service.cookiebot.receives": "Your consent choice",
    "privacy.service.moodle.name": "Moodle",
    "privacy.service.moodle.does": "Hosts Intrivity training courses",
    "privacy.service.moodle.receives": "A signed sign-in token, only if you open the training",
    "privacy.aiHeading": "AI Summary Reports",
    "privacy.ai1": "Where your group has the feature enabled, an administrator can generate a written summary of your results using Google's Gemini model. When that happens, your name and your domain and behaviour scores are sent to Google's API and the returned summary is stored with your report.",
    "privacy.ai2": "Your team-mates' scores are included as context so the summary can compare you with your team, and they are anonymised before being sent — unless the group's administrator has switched that anonymisation off. Your raw survey answers are never sent.",
    "privacy.cookiesHeading": "Cookies and analytics",
    "privacy.cookies": "The public pages use Google Analytics to count visits, and Cookiebot to ask for and record your consent. You can decline non-essential cookies and the assessment will still work. Cookies that are needed to keep you signed in are not optional — without them the service cannot tell who you are.",
    "privacy.retentionHeading": "How long we keep it",
    "privacy.retention1": "Retention periods cannot be determined from the software—nothing in it deletes old accounts, reports or survey responses on a schedule, so in practice data is kept until someone removes it by hand. When a participant leaves the organization that enrolled them, Intrivity will retain their responses in the event that they wish to continue utilizing them on their own or with another organization.",
    "privacy.retention2": "If you wish to remove your survey response and take the survey again or simply delete them, you can email <a href=\"mailto:{email}\">{email}</a> and ask to have your survey response data removed.",
    "privacy.choicesHeading": "Your choices",
    "privacy.choices": "You can edit your name, organisation and job title yourself at any time on the My Intrivity page. To ask for a copy of your data, to correct something you cannot edit, or to have your account and results deleted, contact us at <a href=\"mailto:{email}\">{email}</a>.",
    "privacy.caveat": "<strong>REVIEW BEFORE PUBLISHING.</strong> This section needs the identity of the data controller, the jurisdictions whose rules apply, and the specific rights available to participants under them. If any participants are in the UK, EU or California, the wording here is a legal question rather than a technical one and should be checked by someone qualified.",
    "privacy.changesHeading": "Changes to this page",
    "privacy.changes": "We will update this page whenever what we do with your data changes, and the date below will change with it.",
    "privacy.lastUpdated": "Last updated {date}.",
    "accessibility.title": "Accessibility",
    "accessibility.lede": "Intrivity is committed to making this assessment usable by everyone, including people who browse with a keyboard only, a screen reader, screen magnification, or high-contrast and enlarged text.",
    "accessibility.statusHeading": "Conformance status",
    "accessibility.status": "This application is <strong>partially conformant</strong> with the <a href=\"{url}\" rel=\"noopener noreferrer\" target=\"_blank\">Web Content Accessibility Guidelines (WCAG) 2.1</a>, Level AA. \"Partially conformant\" means most of the application meets the standard, with the exceptions listed under Known limitations below.",
    "accessibility.doneHeading": "What we have done",
    "accessibility.doneIntro": "Both the pages you use to take an assessment and read your results, and the administration screens used by trainers, program managers and administrators, have been reviewed and updated so that:",
    "accessibility.done1": "Every control — navigation, expandable report sections, dialogs and buttons — can be reached and operated with a keyboard alone, and shows a visible focus indicator.",
    "accessibility.done2": "Images carry text descriptions, and the score charts and MRTS shape graphics have text equivalents, so results are never conveyed by colour or shape alone.",
    "accessibility.done3": "Score tables use real table markup, so screen readers can announce which row and column a figure belongs to.",
    "accessibility.done4": "Text meets the AA contrast minimum against its background.",
    "accessibility.done5": "Pages have a title, a language, headings in a meaningful order, and a \"Skip to main content\" link.",
    "accessibility.done6": "Content reflows for zoom and small screens, and animation respects your system's \"reduce motion\" setting.",
    "accessibility.limitsHeading": "Known limitations",
    "accessibility.limitsIntro": "We would rather tell you what still falls short than imply everything is finished. At present:",
    "accessibility.limitAt": "<strong>Assistive technology testing</strong> — our review to date is a technical self-assessment covering the whole application. We have not yet completed testing with screen readers such as JAWS, NVDA or VoiceOver, so issues that only appear in real assistive technology may remain.",
    "accessibility.limitPdf": "<strong>Printable and PDF reports</strong> — the printed and downloaded versions of your report have had less review than the on-screen version. Reports we generate on our own servers do carry the structural tagging that assistive technology relies on, but we have not yet checked that tagging against the PDF/UA standard. Where a report is produced instead by your browser's own \"print to PDF\", the result depends on your browser rather than on us.",
    "accessibility.limitThirdParty": "<strong>Third-party content</strong> — the assessment survey itself is delivered by SurveyMonkey, and payment is handled by Stripe. We do not control the accessibility of those services.",
    "accessibility.feedbackHeading": "Feedback",
    "accessibility.feedback": "We welcome reports of anything that gets in your way — it is the fastest route to getting it fixed. If you encounter a barrier, please contact us at <a href=\"mailto:{email}\">{email}</a> and tell us the page and what happened. We aim to respond within five business days.",
    "accessibility.compatHeading": "Compatibility",
    "accessibility.browsersTerm": "Browsers",
    "accessibility.browsers": "Current versions of Chrome, Edge, Firefox and Safari. Older browsers may work but are not actively tested.",
    "accessibility.atTerm": "Assistive technology",
    "accessibility.at": "The application is built to work with current screen readers and speech input software. See Known limitations above for the current state of testing.",
    "accessibility.techTerm": "Technologies relied upon",
    "accessibility.tech": "HTML, WAI-ARIA, CSS and JavaScript. JavaScript must be enabled for the application to work.",
    "accessibility.assessedHeading": "How this was assessed",
    "accessibility.assessed": "Evaluated by self-assessment against the WCAG 2.1 Level AA success criteria, using a combination of code review, keyboard testing and contrast measurement. No external audit has been carried out.",
    "accessibility.prepared": "Statement prepared {date}. We review this page whenever the application changes materially.",
    "common.yes": "Yes",
    "common.no": "No",
    "field.reportDue": "Report Due",
    "field.stopDate": "Stop Date",
    "field.allowTrainers": "Allow Trainers in Group Report",
    "field.disablePrivacy": "Disable Report Privacy",
    "field.enableAi": "Enable AI Features",
    "role.superadmin": "Superadmin",
    "role.admin": "Admin",
    "role.clientManager": "Client Manager",
    "role.programManager": "Program Manager",
    "role.trainer": "Trainer",
    "role.participant": "Participant",
    "roleGuide.title": "Role Guide",
    "roleGuide.lede": "What each role can see and do across clients, groups, teams, and reports — and how to grant it. Roles are listed from broadest access to narrowest.",
    "roleGuide.colRole": "Role",
    "roleGuide.colScope": "Scope",
    "roleGuide.colManages": "Manages teams & users",
    "roleGuide.colEdits": "Edits client settings",
    "roleGuide.colGranted": "Granted via",
    "roleGuide.can": "Can",
    "roleGuide.cannot": "Cannot",
    "roleGuide.superadmin.scope": "Everything",
    "roleGuide.superadmin.grantedShort": "Global role editor",
    "roleGuide.superadmin.tag": "Full access",
    "roleGuide.superadmin.dek": "Unrestricted access to every client, group, team, and user in Intrivity, including the ability to edit anyone's core profile and hand out any role — including Admin and Superadmin itself.",
    "roleGuide.superadmin.can1": "Everything an Admin can do (see below)",
    "roleGuide.superadmin.can2": "Delete any group or team",
    "roleGuide.superadmin.can3": "Edit a user's core profile — name, paid status, etc.",
    "roleGuide.superadmin.can4": "Directly grant or remove any role on a user's profile",
    "roleGuide.superadmin.can5": "Upload training documents and release them to trainers and program managers",
    "roleGuide.superadmin.cannot1": "Nothing is restricted for this role",
    "roleGuide.superadmin.granted": "<strong>Granted via:</strong> the global role editor on a user's profile — a Superadmin-only screen.",
    "roleGuide.admin.scope": "Everything",
    "roleGuide.admin.grantedShort": "Superadmin sets it",
    "roleGuide.admin.tag": "Every client",
    "roleGuide.admin.dek": "Broad access across every client, with full editing rights on every group and team — minus a couple of Superadmin's most sensitive powers.",
    "roleGuide.admin.can1": "View, create, and edit every client — payment terms, AI features, invitation templates",
    "roleGuide.admin.can2": "Fully edit every field on any group or team (not the limited set Program Managers get)",
    "roleGuide.admin.can3": "Grant Trainer, Program Manager, or Admin on any group, via \"Manage Group Roles\"",
    "roleGuide.admin.can4": "Add or remove Client Managers on a client",
    "roleGuide.admin.cannot1": "Delete a group or team",
    "roleGuide.admin.cannot2": "Edit a user's core profile, or directly change someone's global role checkboxes",
    "roleGuide.admin.granted": "<strong>Granted via:</strong> a Superadmin checks the Admin box on a user's profile.",
    "roleGuide.clientManager.scope": "One or more clients",
    "roleGuide.clientManager.grantedShort": "Added on a client",
    "roleGuide.clientManager.tag": "One or more clients",
    "roleGuide.clientManager.dek": "Everything a Program Manager can do (below), automatically extended to every group and team under one or more specific clients — no need to be added group by group.",
    "roleGuide.clientManager.can1": "Everything a Program Manager can do, across every group/team under their client(s)",
    "roleGuide.clientManager.can2": "Gain access to new groups automatically as they're added to that client",
    "roleGuide.clientManager.cannot1": "See or manage clients they're not assigned to",
    "roleGuide.clientManager.cannot2": "Edit client-level settings — payment, client-wide AI toggle, invitation templates",
    "roleGuide.clientManager.cannot3": "Be counted as a participant in an aggregate group report they manage, even if they took the survey",
    "roleGuide.clientManager.granted": "<strong>Granted via:</strong> an Admin adds them by email under \"Managers\" on a specific client.",
    "roleGuide.programManager.scope": "Assigned groups",
    "roleGuide.programManager.grantedShort": "Added on a group",
    "roleGuide.programManager.tag": "Assigned groups",
    "roleGuide.programManager.dek": "Day-to-day management of the specific groups they've been assigned to — full team and invitation handling, with a deliberately narrow set of group settings they can touch.",
    "roleGuide.programManager.can1": "Create and manage teams; add or remove team members",
    "roleGuide.programManager.can2": "Send, edit, and resend invitations for anyone in their groups",
    "roleGuide.programManager.can3": "View users and generate AI Summary reports, including \"Generate All Summaries\"",
    "roleGuide.programManager.can4": "Edit: <code>{reportDue}</code>, <code>{stopDate}</code>, <code>{allowTrainers}</code>, <code>{disablePrivacy}</code>, and <code>{enableAi}</code> (only if the client itself has AI turned on)",
    "roleGuide.programManager.can5": "Open the released training documents under \"Training Documents\"",
    "roleGuide.programManager.cannot1": "Edit anything else on a group — name, description, join code, payment, SurveyMonkey key",
    "roleGuide.programManager.cannot2": "Delete a group or team",
    "roleGuide.programManager.cannot3": "Edit a team member's profile",
    "roleGuide.programManager.cannot4": "Be counted as a participant in their own group's aggregate report",
    "roleGuide.programManager.granted": "<strong>Granted via:</strong> an Admin adds them via \"Manage Group Roles\" on a specific group.",
    "roleGuide.trainer.scope": "Own invitees in assigned groups",
    "roleGuide.trainer.grantedShort": "Added on a group",
    "roleGuide.trainer.tag": "Own invitees only",
    "roleGuide.trainer.dek": "The narrowest of the assignable roles — built for running your own cohort of invitees inside a group, without management access to the group as a whole.",
    "roleGuide.trainer.can1": "Send invitations, and see/manage only the ones they personally created",
    "roleGuide.trainer.can2": "View reports and generate AI Summaries for their own invitees",
    "roleGuide.trainer.can3": "Access Intrivity's training materials via the \"Intrivity Training\" link",
    "roleGuide.trainer.can4": "Open the released training documents under \"Training Documents\"",
    "roleGuide.trainer.cannot1": "See or manage invitations created by anyone else",
    "roleGuide.trainer.cannot2": "Create or manage teams, or edit any group setting",
    "roleGuide.trainer.cannot3": "Be counted as a participant in the group's aggregate report — unless the group's <code>{allowTrainers}</code> setting is on",
    "roleGuide.trainer.granted": "<strong>Granted via:</strong> an Admin adds them via \"Manage Group Roles\" on a specific group.",
    "roleGuide.participant.scope": "Own results only",
    "roleGuide.participant.grantedShort": "Default — no role",
    "roleGuide.participant.tag": "Own results only",
    "roleGuide.participant.dek": "Every Intrivity user, by default — no admin role of any kind.",
    "roleGuide.participant.can1": "Take the assessment and view their own MRTS profile and domain breakdowns",
    "roleGuide.participant.can2": "Compare their results against a group they belong to, and generate their own AI Summary",
    "roleGuide.participant.can3": "View and print their own report",
    "roleGuide.participant.can4": "Join another group by entering an Intrivity code",
    "roleGuide.participant.cannot1": "See anyone else's individual results",
    "roleGuide.participant.cannot2": "Access any admin screen",
    "roleGuide.participant.granted": "<strong>Granted via:</strong> nothing to do — this is the default state for every account.",
    "roleGuide.combineHeading": "How roles combine",
    "roleGuide.combine1": "A person's access is the sum of everything they've been granted: any global role (Admin/Superadmin, set once on their profile) plus any per-group or per-client roles (Program Manager, Trainer, Admin per group; Client Manager per client).",
    "roleGuide.combine2": "The same person can hold different roles in different places — Program Manager for one group and Trainer for another, for example — and their access reflects all of it at once.",
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.search": "Search",
    "common.edit": "Edit",
    "adminConfig.title": "CONFIGURATION",
    "aiConfig.loadError": "Could not load the AI model configuration: {message}",
    "aiConfig.saved": "AI model configuration saved.",
    "aiConfig.saveError": "Error saving the AI model configuration: {message}",
    "aiConfig.title": "AI Summary Model",
    "aiConfig.hint": "The Gemini model used to generate AI Summary Reports, system-wide. SuperAdmin only. Leave blank to use the system default (currently \"{model}\"). An invalid model name isn't validated up front -- it will only surface as an error the next time someone generates a summary.",
    "aiConfig.viewModels": "View available Gemini models and their endpoints",
    "aiConfig.modelLabel": "Gemini Model",
    "adminDomains.title": "Edit domain feedback:",
    "adminDomains.resume": "Resume Editing {domain}",
    "adminDomains.checkOut": "Check out {domain}",
    "adminDomains.reload": "Reload Domain Configurations Locally",
    "adminSurveys.title": "Manage surveys:",
    "adminUsers.title": "USERS",
    "adminUsers.masquerade": "Masquerade",
    "adminUsers.removeData": "Remove Data",
    "common.back": "Back",
    "common.delete": "Delete",
    "common.true": "True",
    "common.false": "False",
    "common.name": "Name",
    "common.description": "Description",
    "groups.cacheTeamsLookupFailed": "Could not look up the teams for {name}, so nothing was cleared. Check the browser console for the reason.",
    "groups.nameAndTeams": {
        "one": "{name} and its {count} team",
        "other": "{name} and its {count} teams"
    },
    "groups.confirmClearCache": "Clear the cached AI Summary Reports for {label}?\n\nEach one is regenerated the next time someone opens it, which calls the AI model again.",
    "groups.cachePartialFailure": "Some cached AI Summaries for {label} could not be cleared. Check the browser console for the reason.",
    "groups.cacheCleared": {
        "one": "Cleared the cached AI Summaries for {label} — {count} member record.",
        "other": "Cleared the cached AI Summaries for {label} — {count} member records."
    },
    "groups.noDueDate": "No due date has been set for this group.",
    "groups.beforeDueDate": "Summaries can't be generated until the due date ({date}) has passed.",
    "groups.bulkError": "Error generating summaries: {message}",
    "groups.confirmSetDueNow": "No due date has been set for this group. Generating summaries now will set the due date to right now, and any updates made to individual or missing reports after this point will not be included in these summary reports. Do you want to generate all summaries now?",
    "groups.noMembers": "No group/team members were found.",
    "groups.noIndividualReport": "No individual report found yet.",
    "groups.noGroupReport": "Group/team report not available yet.",
    "groups.noneGenerated": "No summaries could be generated.",
    "groups.partialGenerated": "Generated {done} of {total} summaries. The following did not generate -- try again, they usually succeed on a retry:",
    "groups.bulkHeading": "INTRIVITY AI Summaries for {name}",
    "groups.zipFailed": "Failed to generate ZIP: {message}",
    "groups.saved": "Group {name} saved.",
    "groups.confirmDelete": "Delete group {name}?",
    "groups.deleted": "Group {name} deleted.",
    "groups.none": "You currently have no groups to manage.",
    "groups.noDescription": "No Description",
    "groups.joinCode": "Group Join Code {code}",
    "groups.noJoinCode": "Group Join Code: No Code",
    "groups.noPaymentAmount": "No Payment Amount",
    "groups.paymentRequired": "Payment Required",
    "groups.noPaymentRequired": "No Payment Required",
    "groups.invitations": "Invitations",
    "groups.generating": "Generating…",
    "groups.generateAll": "Generate All Summaries",
    "groups.clearing": "Clearing…",
    "groups.clearCache": "Clear AI Cache",
    "groups.clearCacheTitle": "Delete the cached AI Summary Reports for this group and its teams, so they regenerate.",
    "groups.users": "Users",
    "groups.teams": "Teams",
    "groups.editInvitation": "Edit Invitation",
    "groups.privacyOff": "Privacy: Off",
    "groups.privacyOn": "Privacy: On",
    "groups.groupsOf": "Groups of {name}",
    "groups.allClients": "All Clients",
    "groups.add": "Add Group",
    "groups.edit": "Edit Group",
    "groups.downloadHeading": "Download AI Summaries",
    "groups.downloadQuestion": "How would you like to download the AI Summaries for:",
    "groups.individualPdfs": "Individual PDFs (ZIP)",
    "groups.combinedPdf": "Combined PDF",
    "groups.surveyMonkeyKey": "SurveyMonkey Key",
    "groups.reportStatus": "Report Status",
    "groups.statusNone": "None",
    "groups.statusProcess": "Needs Processing",
    "groups.statusReady": "Ready",
    "groups.code": "Group Code",
    "groups.paymentAmount": "Payment Amount",
    "groups.reportDueLong": "Report Due (stop adding late responses)",
    "groups.enabled": "Enabled",
    "groups.enablePrintable": "Enable Printable Report",
    "groups.clientAiDisabled": "This client does not have AI Features enabled.",
    "groups.enableNorm": "Enable Norm Groups",
    "groups.enableCompare": "Enable Group Compare",
    "groups.enableReport": "Enable Report",
    "groups.enableJoining": "Enable Joining",
    "groups.disablePrivacyLong": "Disable Report Privacy (Show Real Names)",
    "groups.restrictComparison": "Restrict Comparison to Own Team",
    "groups.clientId": "Client ID",
    "groups.groupId": "Group ID (UUID)",
    "groups.group": "Group",
    "common.close": "Close",
    "common.invalidDate": "Invalid date",
    "role.user": "User",
    "invitations.status.pending": "Pending",
    "invitations.status.unsent": "Unsent",
    "invitations.status.sent": "Sent",
    "invitations.status.claimed": "Claimed",
    "invitations.notInReportNoReport": "Not in the group report: no report yet.",
    "invitations.notInReportLate": "Not in the group report: survey taken after the due date (taken {taken}, due {due}).",
    "invitations.notInReport": "Not in the group report.",
    "invitations.noEmail": "No email address on invitation.",
    "invitations.noMailFor": "No mail records found for {email}",
    "invitations.mailQueryFailed": "Failed to query mail collection. See console.",
    "invitations.saved": "Invitation for {email} saved.",
    "invitations.chooseCsv": "Choose a CSV file first.",
    "invitations.noGroup": "No group selected.",
    "invitations.noRows": "No rows found in CSV.",
    "invitations.csvInvalidEmail": "Line {line}: invalid email \"{email}\"",
    "invitations.csvImported": {
        "one": "Imported {count} invitation.",
        "other": "Imported {count} invitations."
    },
    "invitations.csvSkipped": "Skipped {count} already invited: {list}",
    "invitations.csvRejected": {
        "one": "{count} row rejected:",
        "other": "{count} rows rejected:"
    },
    "invitations.csvFailed": "CSV import failed: {message}",
    "invitations.confirmDelete": "Delete invitation for {email}?",
    "invitations.deleted": "Invitation for {email} deleted.",
    "invitations.help1": "Status of pending or unsent will send an email to the user within 15 minutes.",
    "invitations.help2": "Do not set a status to sent or claimed. If you do so the email will not get sent.",
    "invitations.help3": "You can resend an email by changing the status from sent to unsent or pending.",
    "invitations.help4": "Do not change a setting from claimed unless you know what you are doing!",
    "invitations.add": "Add Invitation",
    "invitations.edit": "Edit Invitation",
    "invitations.addCsv": "Add Invitation CSV",
    "invitations.csvFile": "Invitation CSV file:",
    "invitations.uploadCsv": "Upload CSV",
    "invitations.statusLine": "Invitation Status: {status}",
    "invitations.joinCode": "Invitation Join Code: {code}",
    "invitations.noCode": "No code",
    "invitations.trainerLine": "Trainer: {email}",
    "invitations.checkMail": "Check Mail",
    "invitations.unpaid": "Unpaid",
    "invitations.unpaidTitle": "This person has not paid the assessment fee for this group.",
    "invitations.seeReport": "See User Report",
    "invitations.noReportYet": "No Report Yet",
    "invitations.statusLabel": "Status",
    "invitations.code": "Code",
    "invitations.cc": "Receive a Copy of Invitation Email",
    "invitations.claimedBy": "Claimed By",
    "invitations.trainerEmail": "Trainer Email",
    "invitations.trainerHelper": "Assigns this invitation to a trainer so they can see it under their Invitations.",
    "invitations.viewMessage": "View Message",
    "invitations.mailHeading": "Mail Sent to Recipient",
    "invitations.mailMessage": "Mail Message",
    "invitations.noSubject": "(no subject)",
    "invitations.to": "To: {email}",
    "invitations.deliveryState": "Delivery state: {state}",
    "invitations.start": "Start: {date}",
    "invitations.end": "End: {date}",
    "invitations.error": "Error: {message}",
    "invitations.accepted": "Accepted: {value}",
    "invitations.rejected": "Rejected: {value}",
    "invitations.pending": "Pending: {value}",
    "invitations.noMail": "No mail records found for that email.",
    "common.remove": "Remove",
    "clients.loadManagersFailed": "Failed to load client managers.",
    "clients.managerAdded": "{name} added as Client Manager.",
    "clients.managerExists": "{name} is already a Client Manager for this client.",
    "clients.addManagerFailed": "Failed to add client manager.",
    "clients.confirmRemoveManager": "Remove {name} as a Client Manager for {client}?",
    "clients.managerRemoved": "{name} removed as Client Manager.",
    "clients.removeManagerFailed": "Failed to remove client manager.",
    "clients.required": "Client Name and Institution are required.",
    "clients.permissionDenied": "Permission denied.",
    "clients.invalidData": "Cannot delete client: Invalid data.",
    "clients.confirmDelete": "Are you sure you want to delete the client \"{name}\"? This action cannot be undone.",
    "clients.deleteFailed": "Failed to delete client: {message}",
    "clients.title": "CLIENTS",
    "clients.noPermission": "You do not have permission to manage clients.",
    "clients.manage": "Manage Clients",
    "clients.none": "No clients found.",
    "clients.noInstitution": "No Institution",
    "clients.noEmail": "No Email",
    "clients.noAddress": "No Address",
    "clients.editNamed": "Edit {name}",
    "clients.managersFor": "Client Managers for {name}",
    "clients.templateFor": "Invitation Template for {name}",
    "clients.deleteNamed": "Delete {name}",
    "clients.edit": "Edit Client",
    "clients.addNew": "Add New Client",
    "clients.pdfBrowser": "Browser Print (default)",
    "clients.pdfBackend": "Server-Generated PDF",
    "clients.save": "Save Client",
    "clients.managers": "Client Managers",
    "clients.managersHelp": "Client Managers automatically manage every group and team under this client, with the same capabilities as a Program Manager.",
    "clients.noManagers": "No Client Managers assigned yet.",
    "clients.add": "Add Client",
    "clients.groups": "Groups",
    "clients.managersButton": "Managers",
    "clients.nameRequired": "Client Name *",
    "clients.institutionRequired": "Institution *",
    "clients.contactEmail": "Contact Email",
    "clients.address": "Address",
    "clients.defaultPayment": "Default Payment",
    "clients.pdfMode": "AI Summary PDF Generation",
    "clients.clientId": "Client ID (UUID)",
    "clients.addManager": "Add Client Manager",
    "clients.client": "Client",
    "common.add": "Add",
    "teamsAdmin.saved": "Team {name} saved.",
    "teamsAdmin.userAdded": "User {user} added to team {team}.",
    "teamsAdmin.addError": "Error adding user to team.",
    "teamsAdmin.confirmRemove": "Are you sure you want to remove {user} from team {team}?",
    "teamsAdmin.userRemoved": "User {user} removed from team {team}.",
    "teamsAdmin.removeError": "Error removing user from team.",
    "teamsAdmin.closeUsers": "Close Users",
    "teamsAdmin.stopEditingMembers": "Stop Editing Team Members",
    "teamsAdmin.editMembers": "Edit Team Members",
    "teamsAdmin.manageUsersFor": "Manage Users for {name}",
    "teamsAdmin.members": "Team Members",
    "teamsAdmin.noUsers": "No users in this team yet.",
    "teamsAdmin.addUsersFrom": "Add Users from {name}",
    "teamsAdmin.loadingUsers": "Loading users...",
    "teamsAdmin.allAdded": "All users from the parent group are already in this team.",
    "teamsAdmin.usersOf": "Users of {name}",
    "teamsAdmin.edit": "Edit Team",
    "teamsAdmin.add": "Add Team",
    "teamsAdmin.parentId": "Parent Group ID",
    "usersAdmin.noMoodlePermission": "Insufficient permissions to create Moodle users.",
    "usersAdmin.noUid": "Selected user has no email/uid.",
    "usersAdmin.creatingMoodle": "Creating Moodle user for {name}...",
    "usersAdmin.moodleCreated": "Moodle user created: {name}",
    "usersAdmin.moodleError": "Error creating Moodle user. See console for details.",
    "usersAdmin.rolesLoadError": "Error loading roles for user.",
    "usersAdmin.noRolesPermission": "Insufficient permissions to modify roles.",
    "usersAdmin.noUser": "No user selected.",
    "usersAdmin.rolesRemoved": "Roles removed for {name}.",
    "usersAdmin.noRolesToRemove": "No roles to remove for {name}.",
    "usersAdmin.rolesUpdated": "Roles updated for {name}.",
    "usersAdmin.rolesSaveError": "Error saving roles.",
    "usersAdmin.addError": "Error adding {name} to group.",
    "usersAdmin.alreadyInGroup": "Already in group.",
    "usersAdmin.added": "{name} added to {group}.",
    "usersAdmin.removed": "{name} removed from {group}.",
    "usersAdmin.removeError": "Error removing {group} from user.",
    "usersAdmin.confirmMoodle": "Create Moodle user for {name}?",
    "usersAdmin.confirmRemove": "Remove {name} from this group?",
    "usersAdmin.roles": "Roles",
    "usersAdmin.createMoodle": "Create Moodle",
    "usersAdmin.manageRoles": "Manage Group Roles",
    "userSearch.heading": "Search users",
    "userSearch.label": "Search by name or email",
    "userSearch.searching": "Searching…",
    "userSearch.none": "No users found",
    "userSearch.select": "Select",
    "userEdit.saved": "User {name} saved.",
    "userEdit.confirmReset": "Are you sure you want to reset user {name}? This will delete their report and responses.",
    "userEdit.reset": "User {name} reset.",
    "userEdit.heading": "Edit User",
    "userEdit.displayName": "Display Name",
    "userEdit.paid": "Paid?",
    "userEdit.process": "Process report?",
    "userEdit.homeGroup": "Home Group ID",
    "userEdit.resetSurvey": "Reset Survey",
    "userEdit.userRoles": "User Roles (not group roles)",
    "removal.category.user-profile": "Account & profile",
    "removal.category.user-profile.detail": "Also removes all group/team membership and cached AI summaries.",
    "removal.category.assessment-report": "Generated assessment report",
    "removal.category.raw-survey-response": "Raw survey response(s)",
    "removal.category.invitations": "Group invitation records",
    "removal.category.group-roles": "Group role assignments",
    "removal.category.client-roles": "Client role assignments",
    "removal.loadFailed": "Could not load this user’s group memberships.",
    "removal.groupsPartial": "Removed from {done} of {total} group(s)/team(s); {failed} failed -- see console.",
    "removal.groupsDone": {
        "one": "Removed from {count} group/team and marked it for reprocessing.",
        "other": "Removed from {count} groups/teams and marked them for reprocessing."
    },
    "removal.erased": {
        "one": "Erased {count} item.",
        "other": "Erased {count} items."
    },
    "removal.eraseFailed": "{count} failed.",
    "removal.reprocessed": {
        "one": "Marked {count} group for reprocessing.",
        "other": "Marked {count} groups for reprocessing."
    },
    "removal.reprocessFailed": {
        "one": "{count} group could not be marked.",
        "other": "{count} groups could not be marked."
    },
    "removal.noGroups": "This user does not belong to any group or team.",
    "removal.teamSuffix": "(team)",
    "removal.hasSummary": " — has cached AI summary",
    "removal.clearsSummary": " — clears cached AI summary",
    "removal.retained": "Payment records and the administrative audit trail are always retained.",
    "removal.willRemove": "Will remove membership in:",
    "removal.willErase": "Will erase:",
    "removal.locationCount": "{label}: {count} item(s)",
    "removal.heading": "Remove User Data",
    "removal.modeGroups": "Remove from selected groups/teams (keeps account and results)",
    "removal.modeFull": "Remove all data (full erasure)",
    "removal.preview": "Preview",
    "removal.loadingPreview": "Loading preview…",
    "removal.confirmLabel": "Type the user's email to confirm",
    "removal.removing": "Removing…",
    "editor.toolbar": "HTML formatting",
    "editor.bold": "Bold",
    "editor.italic": "Italic",
    "editor.underline": "Underline",
    "editor.bulleted": "Bulleted list",
    "editor.numbered": "Numbered list",
    "editor.list": "List",
    "editor.link": "Link",
    "editor.insertLink": "Insert link",
    "editor.removeLink": "Remove link",
    "editor.unlink": "Unlink",
    "editor.clearFormatting": "Clear formatting",
    "editor.clear": "Clear",
    "editor.visual": "Visual Editor",
    "editor.source": "HTML Source",
    "editor.htmlTemplate": "HTML Template",
    "editor.linkPrompt": "Link URL:",
    "editor.subject": "Subject",
    "editor.textTemplate": "Text Template",
    "editor.placeholders": "Placeholders:",
    "defaultTemplate.loadError": "Could not load the default invitation template: {message}",
    "defaultTemplate.saved": "Default invitation template saved.",
    "defaultTemplate.saveError": "Error saving the default invitation template: {message}",
    "defaultTemplate.title": "Default Invitation Email",
    "defaultTemplate.hint": "The system-wide fallback invitation email, used whenever neither a client nor a group has its own override (see each client's/group's own \"{button}\" button). SuperAdmin only.",
    "templateDialog.saveError": "Error saving invitation template: {message}",
    "templateDialog.group.own": "This group has its own saved invitation template.",
    "templateDialog.client.own": "This client has its own saved invitation template.",
    "templateDialog.group.parent": "No override saved yet -- showing this group's client template as a starting point. Saving will make this group's own explicit copy, no longer tied to the client's.",
    "templateDialog.group.default": "No override saved yet -- showing the system default invitation as a starting point. Saving will make this group's own explicit copy, no longer tied to the system default.",
    "templateDialog.client.default": "No override saved yet -- showing the system default invitation as a starting point. Saving will make this client's own explicit copy, no longer tied to the system default.",
    "templateDialog.noSeed": "No override saved, and no default invitation is available to start from.",
    "templateDialog.heading": "Invitation Template",
    "templateDialog.headingFor": "Invitation Template — {name}",
    "templateDialog.group.overrides": "Overrides the system default invitation email for this group. If left blank, this group's client template is used; if that's also blank, the system default is used.",
    "templateDialog.client.overrides": "Overrides the system default invitation email for this client. If left blank, the system default invitation is used.",
    "templateDialog.clearHint": "Leave all three fields blank and save to remove the override.",
    "templateDialog.clearUseDefault": "Clear (Use Default)",
    "compliance.category.hecvat": "HECVAT Workbook",
    "compliance.category.policy": "Policies",
    "compliance.category.audit": "Certifications & Audit Reports",
    "compliance.category.architecture": "Architecture & Data Flow",
    "compliance.category.subprocessors": "Subprocessors & Vendors",
    "compliance.category.accessibility": "Accessibility (VPAT / ACR)",
    "compliance.category.legal": "Legal & Insurance",
    "compliance.category.other": "Other",
    "compliance.loadError": "Could not load the compliance documents: {message}",
    "compliance.chooseFile": "Choose a file to upload first.",
    "compliance.needTitle": "Give the document a title so other admins know what it is.",
    "compliance.tooLarge": "That file is {size}. The limit is {limit}.",
    "compliance.uploaded": "Uploaded \"{title}\".",
    "compliance.uploadFailed": "Upload failed: {message}",
    "compliance.noFile": "\"{title}\" has no stored file — the upload did not finish. Delete the entry and upload it again.",
    "compliance.openFailed": "Could not open that file: {message}",
    "compliance.confirmDelete": "Delete \"{title}\"? This removes the file permanently.",
    "compliance.deleted": "Deleted \"{title}\".",
    "compliance.deleteFailed": "Delete failed: {message}",
    "compliance.addHeading": "Add a document",
    "compliance.file": "File:",
    "compliance.maximum": "{limit} maximum",
    "compliance.uploading": "Uploading…",
    "compliance.upload": "Upload",
    "compliance.loadingDocs": "Loading documents…",
    "compliance.none": "No compliance documents yet. Start with the completed HECVAT workbook, then add the policies and reports it refers to.",
    "compliance.caption": {
        "one": "{count} compliance document, newest first",
        "other": "{count} compliance documents, newest first"
    },
    "compliance.colDocument": "Document",
    "compliance.colCategory": "Category",
    "compliance.colUploaded": "Uploaded",
    "compliance.colSize": "Size",
    "compliance.colActions": "Actions",
    "compliance.title": "COMPLIANCE DOCUMENTATION",
    "compliance.intro": "Evidence for vendor reviews. Higher-education customers typically ask for a completed HECVAT workbook plus the documents it refers out to — security policies, audit reports, an architecture and data-flow description, an accessibility conformance report, and the list of subprocessors.",
    "compliance.stored": "Stored documents",
    "compliance.titleLabel": "Title",
    "compliance.notes": "Notes (optional)",
    "compliance.open": "Open",
    "nav.trainingDocs": "Training Documents",
    "training.title": "TRAINING DOCUMENTS",
    "training.intro": "Material for Intrivity trainers and program managers. A new document is a draft that only administrators can see. Release it to make it available, under Training Documents, to people with the trainer or program manager role; withdraw it to hide it again.",
    "training.addHeading": "Add a training document",
    "training.stored": "Documents",
    "training.needTitle": "Give the document a title so trainers know what it is.",
    "training.uploaded": "Uploaded \"{title}\" as a draft. Release it when it is ready for trainers.",
    "training.uploadFailed": "Upload failed: {message}",
    "training.loadError": "Could not load the training documents: {message}",
    "training.actionFailed": "That did not work: {message}",
    "training.confirmDelete": "Delete \"{title}\"? This removes the file permanently, and trainers will no longer see it.",
    "training.deleted": "Deleted \"{title}\".",
    "training.loading": "Loading documents…",
    "training.none": "No training documents yet. Upload one, then release it when it is ready.",
    "training.caption": {
        "one": "{count} training document, newest first",
        "other": "{count} training documents, newest first"
    },
    "training.colStatus": "Status",
    "training.colReleased": "Released",
    "training.status.draft": "Draft",
    "training.status.released": "Released",
    "training.releasedOn": "Released {date}",
    "training.release": "Release",
    "training.withdraw": "Withdraw",
    "training.releasedMsg": "Released \"{title}\". Trainers and program managers can now see it.",
    "training.withdrawnMsg": "Withdrew \"{title}\". It is a draft again and hidden from trainers.",
    "training.category.facilitator": "Facilitator guides",
    "training.category.participant": "Participant materials",
    "training.category.slides": "Slides",
    "training.category.reference": "Reference",
    "training.category.other": "Other",
    "training.viewer.title": "Training Documents",
    "training.viewer.intro": "Material released for Intrivity trainers and program managers.",
    "training.viewer.none": "No documents have been released yet.",
    "training.viewer.caption": {
        "one": "{count} document, newest first",
        "other": "{count} documents, newest first"
    },
    "audit.event.masquerade.start": "Started masquerading",
    "audit.event.masquerade.end": "Stopped masquerading",
    "audit.event.role.change": "Changed global roles",
    "audit.event.role.group.change": "Changed group roles",
    "audit.event.report.bulk_read": "Read reports in bulk",
    "audit.event.ai_summary.cache_clear": "Cleared AI summary cache",
    "audit.event.user_data.remove_groups": "Removed user from group(s)/team(s)",
    "auditLog.loadError": "Could not load the audit log: {message}",
    "auditLog.weakTitle": "Password sign-in, no second factor",
    "auditLog.weak": "{label} — no second factor",
    "auditLog.loading": "Loading the audit log…",
    "auditLog.none": "No entries yet.",
    "auditLog.noMatch": "No entries match “{filter}”.",
    "auditLog.caption": "{shown} of {total} entries, newest first",
    "auditLog.colWhen": "When",
    "auditLog.colWho": "Who",
    "auditLog.colWhat": "Did what",
    "auditLog.colWhom": "To whom",
    "auditLog.colDetail": "Detail",
    "auditLog.notRecorded": "not recorded",
    "auditLog.serverTrigger": "server trigger",
    "auditLog.title": "AUDIT LOG",
    "auditLog.intro": "Administrative actions that touch someone else's data: masquerade sessions, role changes, bulk report reads and AI cache clears. The collection is append-only — entries cannot be edited or deleted through the application by anyone, including superadmins.",
    "auditLog.filter": "Filter",
    "auditLog.filterPlaceholder": "email, action or group",
    "auditLog.refresh": "Refresh",
    "auditLog.note": "These entries are written by the browser, so they record what the application did — not everything that was possible. Someone with direct console or API access can act without producing an entry. Treat this as an operational record rather than forensic evidence, and say so if asked.",
    "aiModels.title": "Available Gemini Models",
    "aiModels.lede": "Endpoints Gemini currently exposes, for use with the AI Summary Model setting in Configuration. Only text-generation models return the plain-text/JSON response the AI Summary Report feature expects -- image, live-streaming, and text-to-speech endpoints are listed for completeness but aren't a fit for it.",
    "aiModels.colModel": "Model",
    "aiModels.colEndpoint": "Endpoint",
    "aiModels.colType": "Type",
    "aiModels.colFits": "Fits AI Summary Reports?",
    "aiModels.colNotes": "Notes",
    "aiModels.unconfirmed": "Unconfirmed",
    "aiModels.disclaimer": "Endpoint names and availability are controlled by Google and can change without notice -- a \"preview\" endpoint especially may be renamed, changed, or retired at any time. If the AI Summary Model setting is pointed at an endpoint that stops being available, generating a summary will fail with an error until it's updated to a current one.",
    "aiModels.type.textFlash": "Text — Flash",
    "aiModels.type.textFlashLite": "Text — Flash-Lite",
    "aiModels.type.image": "Image generation",
    "aiModels.type.textProPreview": "Text — Pro (preview)",
    "aiModels.type.textFlashPreview": "Text — Flash (preview)",
    "aiModels.type.liveTranslate": "Live/streaming translation",
    "aiModels.type.live": "Live/streaming",
    "aiModels.type.tts": "Text-to-speech",
    "aiModels.type.omni": "Multimodal (omni)",
    "aiModels.note.fastDefault": "Fast, general-purpose text generation. Good default choice.",
    "aiModels.note.previousFlash": "Previous Flash generation.",
    "aiModels.note.lighter": "Lighter/cheaper and faster; may trade off answer quality.",
    "aiModels.note.olderLight": "Older lightweight variant.",
    "aiModels.note.images": "Produces images, not text.",
    "aiModels.note.proPreview": "Higher-quality, slower reasoning. Preview: may change or be retired without notice.",
    "aiModels.note.preview": "Preview: may change or be retired without notice.",
    "aiModels.note.streaming": "Built for real-time streaming sessions, not one-shot text generation.",
    "aiModels.note.audio": "Produces audio, not text.",
    "aiModels.note.omni": "Multimodal; fit for plain-text summary generation is unconfirmed.",
    "domainEditor.field.description": "Description",
    "domainEditor.field.domainFeedback": "Domain Level Feedback",
    "domainEditor.field.characteristicName": "Characteristic Name",
    "domainEditor.field.likertLabels": "Likert Scale Labels",
    "domainEditor.field.characteristicFeedback": "Characteristic Feedback",
    "domainEditor.field.characteristicBehaviors": "Characteristic Behaviors",
    "domainEditor.field.behaviorName": "Behavior Name",
    "domainEditor.field.behaviorQuote": "Behavior Quote",
    "domainEditor.field.behaviorDefinition": "Behavior Definition",
    "domainEditor.field.behaviorSample": "Behavior Sample",
    "domainEditor.field.behaviorMeaning": "Behavior Meaning",
    "domainEditor.field.behaviorStrengths": "Behavior Strengths",
    "domainEditor.field.behaviorRecommendations": "Behavior Recommendations",
    "domainEditor.field.attitudeName": "Attitude Name",
    "domainEditor.field.attitudeQuote": "Attitude Quote",
    "domainEditor.field.attitudeDefinition": "Attitude Definition",
    "domainEditor.field.attitudeSample": "Attitude Sample",
    "domainEditor.field.attitudeMeaning": "Attitude Meaning",
    "domainEditor.field.attitudeStrengths": "Attitude Strengths",
    "domainEditor.field.attitudeRecommendations": "Attitude Recommendations",
    "domainEditor.loadFailed": "Could not load data.",
    "domainEditor.saved": "Your changes have been saved.",
    "domainEditor.published": "Your changes have been published.",
    "domainEditor.saveFailed": "There was a problem saving your changes.",
    "domainEditor.publishFailed": "There was a problem publishing your changes.",
    "domainEditor.released": "File released.",
    "domainEditor.deleteFailed": "Deletion failed for {name}.",
    "domainEditor.reverted": "Changes have been reverted.",
    "domainEditor.nothingToCancel": "No changes to cancel.",
    "domainEditor.nothingToSave": "No changes to save.",
    "domainEditor.confirmRelease": "Are you sure you want to release your checkout?  Any unpublished changes will be lost.",
    "domainEditor.confirmPublish": "Are you sure you want to publish your changes?  This will update the production data and release the checkout.",
    "domainEditor.saveFirst": "You must save your changes before you can publish them.",
    "domainEditor.intro": "This editor will allow you to change any text directly that is colored blue.  You may use HTML code if you like but the HTML will not be rendered (you won't see it change on this screen and you will see the HTML code).  Only one user can edit one domain at a time- it will be locked to other users until the edit is saved or cancelled.  Saving changes will immediately publish those changes and subsequent loads of the application will see these changes. The save and cancel options appear at the bottom of this page.",
    "domainEditor.warning": "<span style=\"font-weight: bold;\">Warning:</span> if you leave this page- for example by choosing a menu item on the left- the editor will act as if you clicked the Cancel button and any changes you have made since your last Save will be lost.",
    "domainEditor.editingBy": "Editing by {editor} checked out at {date}.",
    "domainEditor.publish": "Publish",
    "domainEditor.release": "Release",
    "domainEditor.history": "History:",
    "domainEditor.historyEntry": "{date} by {editor}",
    "domainEditor.checkedOutBy": "This domain is checked out by {editor}.",
    "domainEditor.checkedOutAt": "Checked out at {date}",
    "domainEditor.couldNotLoad": "Could not load...",
    "usersAdmin.addUser": "Add User",
    "overview.shapeLine1": "MRTS",
    "overview.shapeLine2": "SHAPE",
    "groups.trainerGroups": "TRAINER GROUPS",
    "groups.pmGroups": "PROGRAM MANAGER GROUPS",
    "groups.welcomeTrainer": "Welcome Intrivity Trainer! Your groups are listed below.",
    "groups.welcomePm": "Welcome Intrivity Program Manager! Your groups are listed below.",
    "domain.scoreBetween": "Your score is between {low} and {high}.",
    "clients.saveFailed": "Failed to save client: {message}",
    "userSearch.failed": "Search failed. Check console for details.",
    "adminDomains.language": "Language to edit:",
    "invitationLanguage.editing": "Language of this version:",
    "invitationLanguage.hint": "Each invitation is sent in the invitee's language (set on the invitation, the group or the client). If there is no version in that language, the English one is sent. [[link]] opens the app in the email's language.",
    "invitationLanguage.line": "Invitation language: {language}",
    "invitationLanguage.label": "Invitation language:",
    "invitationLanguage.groupDefault": "Group default",
    "invitationLanguage.clientDefault": "Client default",
    "invitationLanguage.groupDefaultLabel": "Default invitation language:",
    "invitationLanguage.clientDefaultLabel": "Default invitation language:",
    "invitationLanguage.csvUnknown": "Line {line}: unknown language \"{language}\" (use one of: {known})"
};
